import { Chip } from "components/DesignSystem/Chips/Chips";
import { CustomerFeedbackSection } from "types/Models/reviewDocumentAndBalancingPayment";

export const FeedbackSectionInput = ({
  section,
  selectedChoices,
  onToggleChoice,
  readonly = false,
}: {
  section: CustomerFeedbackSection;
  selectedChoices: string[];
  onToggleChoice: (choice: string) => void;
  readonly?: boolean;
}) => {
  return (
    <div className="t-flex t-flex-col t-gap-2.5">
      <div className="t-text-body-sm t-text-text-30 t-text-center">
        {section.label}
      </div>
      <div className="t-flex t-flex-wrap t-gap-2 t-justify-center">
        {section.choices.map((choice) => (
          <Chip
            key={choice}
            isActive={selectedChoices.includes(choice)}
            isRemovable={!readonly}
            onRemove={() => onToggleChoice(choice)}
            onClick={() => onToggleChoice(choice)}
            rounded
            disabled={readonly}
            size="small"
            isFixedFilter
            type="button"
          >
            {choice}
          </Chip>
        ))}
      </div>
    </div>
  );
};
